
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/search",
      function () {
        return require("private-next-pages/default/desktop/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/search"])
      });
    }
  